/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-imports  */

import { DOCUMENT } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  SecurityContext,
  Inject,
} from '@angular/core';

import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { MenuItem, Menu, SubMenu } from '@cigna/cigna-for-brokers/shared/util';
import {
  AppStateGateway,
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
// eslint-disable-next-line no-restricted-imports
import { isEmpty } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { StatementAccessRequestDialogComponent } from '../statement-access-request-dialog/statement-access-request-dialog.component';
import { Router } from '@angular/router';
import {
  PostAffirmRequestPayload,
  AppFacade,
  Agency,
} from '@cigna/cigna-for-brokers/shared/data-access';
import {
  AppstateFacade,
  Clients,
  Entitlement,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LegalAffirmationModalComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import includes from 'lodash/includes';
import { BrokerMainMenu, BrokerMenuItem } from '../+state/menu-nav.models';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cigna-caprimary-nav',
  templateUrl: './primary-nav.component.html',
  styleUrls: ['./primary-nav.component.scss'],
})
export class PrimaryNavComponent implements OnInit, OnChanges {
  @ViewChild(LegalAffirmationModalComponent, { static: true })
  child: LegalAffirmationModalComponent;

  @Input() menuItemsWithSubMenu?: Menu[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() sideBarToggleFlag: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  items: MenuItem[] = [];
  profileItems: MenuItem[] = [];
  communicationItems: MenuItem[] = [];
  brokerMenu: BrokerMainMenu;
  usEmployerOnlyMenu?: BrokerMenuItem;
  goToLink: MenuItem;
  isLinkEnabled: boolean;
  isGetAgencyFailed: boolean;
  urlPath = window.location.origin;
  @Input() isScreenSmall: boolean;
  @Input() navigationEntitlements: string[] | undefined;
  @Output() openExternalPage = new EventEmitter<{ source: string }>();
  @Input() source: string;
  @Input() isImpersonatorFlag: boolean;

  @Output() appRedirect = new EventEmitter<{ redirect: string }>();
  @Output() windowOpen = new EventEmitter<{ url: string; target: string }>();
  @Output() FundingSolRedirect = new EventEmitter<{}>();
  @Output() closeMenuEmitter = new EventEmitter();

  getIsGetAgencyListFailed$ = this._appFacade.getIsGetAgencyListFailed$;
  legalAffirmStatus$ = this._appstateFacade.legalAffirmStatus$;
  detailsErrorAppShared$ = this._appFacade.detailsError$;
  agencyList$ = this._appFacade.agencyList$;
  loadingAppShared$ = this._appFacade.loading$;
  isPostAffirmFailed$ = this._appFacade.getIsPostAffirmFailed$;
  affirmResponse$ = this._appFacade.getAffirmResponse$;
  tools$ = this._appstateFacade.tools$;
  statementAccessRequest$ = this._appstateFacade.statementAccessRequest$;
  agencyResponse$ = this._appFacade.agencyResponse$;
  isOnDemandTrainingEducationToggleOn: boolean;
  hasIfpAdminMenu = false;
  isUsEmployerOnly = false;
  isOnDemandTrainingEducationEnabled$ =
    this.featureTogglesFacade.featuresEnabled([
      'isOnDemandTrainingEducationEnabled',
    ]);

  isMaCompensationToggleOn: boolean;
  isMaCompensationnEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isMaCompensationEnabled',
  ]);
  isOpenEnrollmentEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOpenEnrollmentEnabled',
  ]);
  isIFPMphasisEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isIFPMphasisEnabled',
  ]);

  isOpenEnrollmentEnabledFlag: boolean;
  // isIFPMphasisEnabledFlag: boolean;
  isBackLink: boolean;
  isTest: boolean;
  isViewStatmtLink: boolean;
  isLegalAffirmOpen: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  hasBoBMA$ = this._appstateFacade.hasOneOfEntitlements$([Entitlement.BoBMA]);
  hasBoBMAInt$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.BoBMAInt,
  ]);
  hasBoBMaApplicationStatusExt$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.BoBMaApplicationStatusExt,
  ]);
  hasBoBMaApplicationStatusInt$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.BoBMaApplicationStatusInt,
  ]);

  hasCommercialCompensationStatements$ =
    this._appstateFacade.hasOneOfEntitlements$([
      Entitlement.CommercialCompensationStatements,
    ]);
  envName: string;
  isNewMarketingMaterialsEnabledFlag: boolean;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _sanitizer: DomSanitizer,
    private _gw: AppStateGateway,
    public _appstateFacade: AppstateFacade,
    public _appFacade: AppFacade,
    public router: Router,
    public dialog: MatDialog,
    public featureTogglesFacade: FeatureTogglesFacade,
    private _translateService: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {
    const brokerObj = this._translateService.instant(`broker`);
    if (brokerObj) {
      this.brokerMenu = cloneDeep(get(brokerObj, 'mainMenu'));
      this.usEmployerOnlyMenu = cloneDeep(get(brokerObj, 'usEmployerOnlyMenu'));
    }
  }
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  ngOnInit(): void {
    this.isOpenEnrollmentEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOpenEnrollmentEnabled) => {
        this.isOpenEnrollmentEnabledFlag = isOpenEnrollmentEnabled;
      });

    /*
    this.isIFPMphasisEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isIFPMphasisEnabled) => {
        this.isIFPMphasisEnabledFlag = isIFPMphasisEnabled;
      });
      */

    this.envName = this._config.environmentName;
    const featureFlagBase = this._translateService.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);

    // this.isIFPMphasisEnabledFlag = get(flagObj, 'isIFPMphasisEnabled');

    this.isNewMarketingMaterialsEnabledFlag = get(
      flagObj,
      'isNewMarketingMaterialsEnabled',
    );

    this.buildSelectedClientMenusWithSubMenu();
    this.isLegalAffirmOpen = false;
    this.isBackLink = false;
    this.isViewStatmtLink = false;
    this.legalAffirmStatus$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: boolean) => {
        this.isLegalAffirmOpen = res;
      });

    this.getIsGetAgencyListFailed$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: boolean) => {
        this.isGetAgencyFailed = res;
      });

    this.isOnDemandTrainingEducationEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOnDemandTrainingEducationEnabled) => {
        this.isOnDemandTrainingEducationToggleOn =
          isOnDemandTrainingEducationEnabled;
      });

    this.isMaCompensationnEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isMaCompensationnEnabled) => {
        this.isMaCompensationToggleOn = isMaCompensationnEnabled;
      });

    /* istanbul ignore next */
    if (includes(this.urlPath, 'ifpadmin')) {
      this.hasIfpAdminMenu = true;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.selectedClient !== undefined &&
        changes.selectedClient.previousValue &&
        changes.selectedClient.currentValue !==
          changes.selectedClient.previousValue) ||
      (changes.menuItemsWithSubMenu &&
        changes.menuItemsWithSubMenu.currentValue !==
          changes.menuItemsWithSubMenu.previousValue)
    ) {
      this.buildSelectedClientMenusWithSubMenu();
    }
    this.isMaCompensationnEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isMaCompensationnEnabled) => {
        this.isMaCompensationToggleOn = isMaCompensationnEnabled;
      });
  }
  goToFundingSolution() {
    this.FundingSolRedirect.emit();
  }
  goToCommercialCompStmt() {
    let isStatementAccessRequest = false;

    this.statementAccessRequest$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: boolean) => {
        isStatementAccessRequest = res;
      });
    this.agencyList$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: Agency[]) => {
        if (res.length === 0) {
          isStatementAccessRequest = true;
        } else {
          isStatementAccessRequest = false;
        }
      });
    if (this.isLegalAffirmOpen) {
      this.child.openLegalAffirmFn();
      this.isBackLink = true;
    } else {
      if (isStatementAccessRequest) {
        const dialogRef = this.dialog.open(
          StatementAccessRequestDialogComponent,
          {
            width: '700px',
            data: {
              isImpersonatorFlag: this.isImpersonatorFlag,
            },
          },
        );

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.router.navigate(['/secure/commercial/compensation/manage']);
          }
        });
      } else {
        this.router.navigate(['/secure/commercial/compensation/']);
      }
    }
  }

  goToSolutionsAndInsights() {
    if (this.isNewMarketingMaterialsEnabledFlag) {
      this.router.navigate(['/secure/commercial/marketing-materials/']);
    } else {
      this.router.navigate(['/secure/commercial/solutions-insights/']);
    }
  }

  goToCSBIncentives() {
    this.router.navigate(['/secure/csb/incentives']);
  }

  goToMaCompensationPage() {
    this.router.navigate(['/secure/ma/compensation/']);
  }

  submitLegalAffirm(request: PostAffirmRequestPayload) {
    this._appFacade.postAffirm(request);
  }

  sanitiseHhtmlProperty(_htmlProperty: string | number) {
    return this._sanitizer.sanitize(SecurityContext.HTML, _htmlProperty);
  }
  openExternal(data: { source: string }) {
    if (data.source === 'Utilization') {
      this.document.getElementById('cap-reports').target = '_blank';
      this.document.getElementById('cap-reports').submit();
    } else if (data.source === 'smenu-ind-sep-work-queue') {
      window.open(this._gw.getSepWorkQExtUrl(), '_blank');
    } else if (data.source === 'smenu-ind-administration') {
      window.open(this._gw.getIfpAdminUrl(), '_self');
    } else {
      this.openExternalPage.emit(data);
    }
  }

  redirect(data: { redirect: string }) {
    this.appRedirect.emit(data);
  }
  navigateExternal(data: { url: string; target: string }) {
    this.windowOpen.emit(data);
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity
  buildSelectedClientMenusWithSubMenu() {
    this.clearMenuCache();
    this.buildBrokerPortalMenu();
  }

  goToBookOfBusinessPage() {
    const slectedNavItem = window.localStorage.getItem('selectedNav');
    const routeItem =
      slectedNavItem === 'reqForProposal'
        ? 'requestforproposal'
        : 'currentbusiness';

    if (routeItem === 'requestforproposal') {
      this.router.navigate(['/secure/commercial/book-of-business/rfp']);
      return;
    }
    if (routeItem === 'currentbusiness') {
      this.router.navigate(['/secure/commercial/book-of-business/']);
    }
  }

  goToSmallGroupRenewalsPage() {
    this.router.navigate(['/secure/sgp/renewals']);
  }

  getMaterialResourcesSubMenu() {
    return JSON.parse(`
    [
      {
        "text": "Booklets",
        "entitlement" : "ftr-smenu-mr-booklets",
        "icon": "external-link",
        "route": ""
      },
      {
        "text": "Member Materials",
        "entitlement" : "ftr-smenu-mr-compliance",
        "icon": "",
        "route": "app/secure/cfe/account-materials/member"
      },
      {
        "text": "Transparency in Coverage",
        "entitlement" : "ftr-smenu-mr-compliance",
        "icon": "",
        "route": "app/secure/cfe/account-materials/coverage-transparency"
      }
   ]`);
  }

  getProfileSubMenu() {
    return JSON.parse(`
    [
      {
        "text": "User Setup",
        "entitlement": "ftr-smenu-pa-setup",
        "route": "app/secure/cfe/admin/user-admin",
        "icon": ""
      }
    ]`);
  }

  clearMenuCache() {
    this.items = [];
    this.profileItems = [];
    this.communicationItems = [];
  }

  // BROKERS Portal
  getCommercialPlan(): any {
    return this.brokerMenu.commercial.menuItems;
  }
  getSGPPlan(): any {
    return this.brokerMenu.sgp.menuItems;
  }

  getIndvFamilySubMenu(): any {
    /*
    this.isIFPMphasisEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isIFPMphasisEnabled) => {
        this.isIFPMphasisEnabledFlag = isIFPMphasisEnabled;
      });


    this.envName = this._config.environmentName;
    const featureFlagBase = this._translateService.instant(`featureFlag`);

    const linkEndDate = this._translateService.instant(
      'global.2025linkEndDate',
    );
  */

    return this.brokerMenu.ifp.menuItems;
  }

  getMedCareAdSubMenu(): any {
    return this.brokerMenu.ma.menuItems;
  }

  getCignaSupplSubMenu(): any {
    return this.brokerMenu.csb.menuItems;
  }

  getSubMenuItems(subMenus: MenuItem[], parentMenuIndex: number): MenuItem[] {
    if (isEmpty(subMenus)) {
      return [];
    }

    const subMenuItems: MenuItem[] = [];
    for (const subMenu of subMenus) {
      const subMenuEntitlements = this.menuItemsWithSubMenu?.[
        parentMenuIndex
      ].subMenus?.find((y) =>
        Array.isArray(subMenu.entitlement)
          ? subMenu.entitlement.includes(y.entitlement)
          : y.entitlement === subMenu.entitlement,
      );

      if (!subMenuEntitlements) {
        continue;
      }

      const l3MenuEntitlements = subMenuEntitlements?.l3Menus;

      if (isEmpty(l3MenuEntitlements) || isEmpty(subMenu.submenu)) {
        subMenuItems.push(subMenu);
        continue;
      }

      const l3SubMenus = subMenu.submenu
        ?.filter((x: MenuItem) =>
          l3MenuEntitlements?.find((y) =>
            Array.isArray(x.entitlement)
              ? x.entitlement.includes(y.entitlement)
              : y.entitlement === x.entitlement,
          ),
        )
        .map((x: MenuItem) => ({
          ...x,
          ...{
            // eslint-disable-next-line sonarjs/no-identical-functions
            isExternal: l3MenuEntitlements?.find((y) =>
              Array.isArray(x.entitlement)
                ? x.entitlement.includes(y.entitlement)
                : y.entitlement === x.entitlement,
            )?.isExternal,
          },
        }));

      subMenuItems.push({ ...subMenu, ...{ submenu: l3SubMenus } });
    }
    return subMenuItems;
  }

  buildBrokerPortalMenu() {
    if (this.menuItemsWithSubMenu && this.menuItemsWithSubMenu.length > 0) {
      this.items.push({
        text: this.brokerMenu.dashboard,
        icon: 'house',
        route: 'secure/home',
      });

      // Determine if the user only has access to Commercial Plans and build menu accordingly
      this.isUsEmployerOnly = this.menuItemsWithSubMenu
        .filter((menuItem) => menuItem.entitlement !== 'menu-dashboard')
        .every((menuItem) => menuItem.entitlement === 'menu-commercial-plans');

      const usEmployerMenu = this.menuItemsWithSubMenu.find(
        (menuItem) => menuItem.entitlement === 'menu-commercial-plans',
      );

      if (
        this.isUsEmployerOnly &&
        usEmployerMenu?.subMenus &&
        this.usEmployerOnlyMenu?.menuItems
      ) {
        for (const menuItem of this.usEmployerOnlyMenu.menuItems) {
          if (
            usEmployerMenu.subMenus.some(
              (subMenu) => subMenu.entitlement === menuItem.entitlement,
            )
          ) {
            this.items.push({
              text: menuItem.text,
              icon: menuItem.icon,
              route: menuItem.route,
              entitlement: menuItem.entitlement,
              submenu:
                menuItem.entitlement === 'smenu-commercial-tools'
                  ? menuItem.submenu
                  : [],
            });
          }
        }

        // Else, build the menu with all available plans
      } else {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.menuItemsWithSubMenu.length; i = i + 1) {
          if (
            this.menuItemsWithSubMenu[i].entitlement === 'menu-commercial-plans'
          ) {
            this.items.push({
              text: this.brokerMenu.commercial.text,
              icon: 'user-group-solid-3',
              route: '',
              ...(this.menuItemsWithSubMenu[i].subMenus && {
                submenu: this.getSubMenuItems(this.getCommercialPlan(), i),
              }),
            });
          } else if (this.menuItemsWithSubMenu[i].entitlement === 'menu-sgp') {
            this.items.push({
              text: this.brokerMenu.sgp.text,
              icon: 'user-group-solid',
              route: '',
              ...(this.menuItemsWithSubMenu[i].subMenus && {
                submenu: this.getSubMenuItems(this.getSGPPlan(), i),
              }),
            });
          } else if (
            this.menuItemsWithSubMenu[i].entitlement === 'menu-indv-family'
          ) {
            this.items.push({
              text: this.brokerMenu.ifp.text,
              icon: 'personal-guide',
              route: '',
              ...(this.menuItemsWithSubMenu[i].subMenus && {
                submenu: this.getSubMenuItems(this.getIndvFamilySubMenu(), i),
              }),
            });
          } else if (
            this.menuItemsWithSubMenu[i].entitlement === 'menu-med-advan'
          ) {
            this.items.push({
              text: this.brokerMenu.ma.text,
              icon: 'hand-holding-heart-solid',
              route: '',
              ...(this.menuItemsWithSubMenu[i].subMenus && {
                submenu: this.getSubMenuItems(this.getMedCareAdSubMenu(), i),
              }),
            });
          } else if (
            this.menuItemsWithSubMenu[i].entitlement === 'menu-cigna-suppl'
          ) {
            this.items.push({
              text: this.brokerMenu.csb.text,
              icon: 'suitcase-medical-solid',
              route: '',
              ...(this.menuItemsWithSubMenu[i].subMenus && {
                submenu: this.getSubMenuItems(this.getCignaSupplSubMenu(), i),
              }),
            });
          } else if (
            this.menuItemsWithSubMenu[i].entitlement === 'menu-pres-drug-plan'
          ) {
            this.items.push({
              text: this.brokerMenu.pdp.text,
              icon: 'prescription-bottle-solid',
              route: '/secure/pdp-home',
            });
          }
        }
      }
    }
  }
  closeMenu() {
    this.closeMenuEmitter.emit();
  }
}
